import { JSX } from "react";
import { ChoiceSelectionHeader } from "./components/ChoiceSelectionHeader";
import { ChoiceSelectionCard } from "./components/ChoiceSelectionCard";
import { Logo } from "../../common/svg/Logo";
import { useAppDispatch } from "../../app/hooks";
import { handleChoiceSelection } from "./utils/handleChoiceSelection";
import { useNavigate } from "react-router-dom";
import sprsoBrownImage from "../../common/images/sprso-brown.png";
import sprsoBlueImage from "../../common/images/sprso-blue.png";
import sprsoGrayImage from "../../common/images/sprso-gray.png";
import sprsoYellowImage from "../../common/images/sprso-yellow.png";
import { ColorsEnum } from "../../common/enums/ColorsEnum";
import { TitlesEnum } from "../../common/enums/TitlesEnum";
import { CSVLink } from "react-csv";
import { useExportToCsv } from "./hooks/useExportToCsv";

export const ChoiceSelectionPageContainer = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { csvData, showCSVLink, csvHeaders, handleLogoClick } =
        useExportToCsv();

    return (
        <div className={"p-choice-selection"}>
            <ChoiceSelectionHeader />
            <div className={"p-choice-selection__content"}>
                <ChoiceSelectionCard
                    imgSrc={sprsoBrownImage}
                    color={ColorsEnum.DARK_ROAST}
                    title={TitlesEnum.DARK_ROAST}
                    onClick={() =>
                        handleChoiceSelection({
                            dispatch,
                            navigate,
                            choice: TitlesEnum.DARK_ROAST,
                        })
                    }
                />
                <ChoiceSelectionCard
                    imgSrc={sprsoBlueImage}
                    color={ColorsEnum.PASTEL_BLOOM}
                    title={TitlesEnum.PASTEL_BLOOM}
                    onClick={() =>
                        handleChoiceSelection({
                            dispatch,
                            navigate,
                            choice: TitlesEnum.PASTEL_BLOOM,
                        })
                    }
                />
                <ChoiceSelectionCard
                    imgSrc={sprsoGrayImage}
                    color={ColorsEnum.WHITE_LATTE}
                    title={TitlesEnum.WHITE_LATTE}
                    onClick={() =>
                        handleChoiceSelection({
                            dispatch,
                            navigate,
                            choice: TitlesEnum.WHITE_LATTE,
                        })
                    }
                />
                <ChoiceSelectionCard
                    imgSrc={sprsoYellowImage}
                    color={ColorsEnum.BRIGHT_YELLOW}
                    title={TitlesEnum.BRIGHT_YELLOW}
                    onClick={() =>
                        handleChoiceSelection({
                            dispatch,
                            navigate,
                            choice: TitlesEnum.BRIGHT_YELLOW,
                        })
                    }
                />
            </div>
            <div
                className={"p-choice-selection__footer"}
                onClick={handleLogoClick}
            >
                <Logo />
            </div>
            {showCSVLink && (
                <CSVLink
                    data={csvData}
                    headers={csvHeaders}
                    filename={`vote_export_${new Date().toISOString().split("T")[0]}.csv`}
                    className="csv-download-link"
                    style={{ display: "none" }}
                >
                    Download CSV
                </CSVLink>
            )}
        </div>
    );
};
